import { Storybook } from "@tento-ui/ui/storybook";
import { PillSelect } from "./pill-select";

export class PillSelectStoryBook extends Storybook.Default {
  title(): string {
    return "Pill Select";
  }

  examples(): Storybook.Example[] {
    return [
      {
        title: "Basic",
        render: () => {
          return PillSelect.make().bind("monthly", [
            { label: "Daily", identifier: "daily" },
            { label: "Weekly", identifier: "weekly" },
            { label: "Monthly", identifier: "monthly" },
          ]);
        },
      },
      {
        title: "With onChange",
        render: () => {
          const $select = PillSelect.make().bind("low", [
            { label: "Low", identifier: "low" },
            { label: "Medium", identifier: "medium" },
            { label: "High", identifier: "high" },
          ]);
          const $status = Storybook.Card.StatusLine.make();
          $status.bindText("Selected: low");
          $select.onSelected = (value) => {
            $status.bindText(`Selected: ${value}`);
          };
          return { $content: $select, $status };
        },
      },
      {
        title: "Many options (wrapping)",
        render: () => {
          const $select = PillSelect.make().bind("react", [
            { label: "React", identifier: "react" },
            { label: "Vue", identifier: "vue" },
            { label: "Angular", identifier: "angular" },
            { label: "Svelte", identifier: "svelte" },
            { label: "Solid", identifier: "solid" },
            { label: "Preact", identifier: "preact" },
          ]);
          $select.style.width = "300px";
          return $select;
        },
      },
      {
        title: "Long labels (truncated)",
        render: () => {
          return PillSelect.make().bind("recent-1", [
            { label: ":~weather:location:12345", identifier: "recent-1" },
            { label: "ss_very_long_sheet_key_name", identifier: "recent-2" },
            { label: "[@user]:tasks:completed", identifier: "recent-3" },
          ]);
        },
      },
    ];
  }
}
